import type { AnchorHTMLAttributes, ReactNode } from 'react';
import type { LinkProps } from 'react-router';
import { Link } from 'react-router';

interface SmartLinkProps {
  anchorProps?: AnchorHTMLAttributes<HTMLAnchorElement>;
  children?: ReactNode;
  className?: string;
  linkProps?: Omit<LinkProps, 'to'>;
  to?: string;
}

const SmartLink = ({ anchorProps, children, className, linkProps, to }: SmartLinkProps) => {
  const isExternalLink = to && /^https?:\/\//.test(to);

  if (isExternalLink) {
    return (
      <a className={className} href={to} rel="noopener noreferrer" {...anchorProps}>
        {children}
      </a>
    );
  }

  return (
    <Link className={className} to={to ?? ''} {...linkProps}>
      {children}
    </Link>
  );
};

export default SmartLink;
